/**
 * MethodScript VarType Definitions
 * Auto-generated by generate-vartypes.js
 */

export type VarTypeDefinition = {
    label: string;
    doc: string;
};

export const VARTYPES: Array<VarTypeDefinition> = [
    { label: 'aa', doc: 'VT_UNKNOWN - Unknown (not initialized)' },
    { label: 'ab', doc: 'VT_POTENTIAL - Measured WE voltage vs RE' },
    { label: 'ac', doc: 'VT_POTENTIAL_CE - Measured CE voltage vs GND' },
    { label: 'ad', doc: 'VT_POTENTIAL_SE - Measured SE voltage vs GND' },
    { label: 'ae', doc: 'VT_POTENTIAL_RE - Measured RE voltage vs GND' },
    { label: 'af', doc: 'VT_POTENTIAL_WE - Measured WE vs GND' },
    { label: 'ag', doc: 'VT_POTENTIAL_WE_VS_CE - Measured WE voltage vs CE' },
    { label: 'ah', doc: 'VT_POTENTIAL_S2_VS_RE - Measured second sense voltage vs RE' },
    { label: 'ai', doc: 'VT_POTENTIAL_SE_VS_S2 - Measured SE voltage vs second sense' },
    { label: 'as', doc: 'VT_POTENTIAL_AIN0 - Measured analog input 0 voltage' },
    { label: 'at', doc: 'VT_POTENTIAL_AIN1 - Measured analog input 1 voltage' },
    { label: 'au', doc: 'VT_POTENTIAL_AIN2 - Measured analog input 2 voltage' },
    { label: 'ba', doc: 'VT_CURRENT - Measured WE current' },
    { label: 'bb', doc: 'VT_CURRENT_BIPOT - Measured WE2 current' },
    { label: 'ca', doc: 'VT_PHASE - Measured phase' },
    { label: 'cb', doc: 'VT_IMP - Measured impedance' },
    { label: 'cc', doc: 'VT_ZREAL - Measured real part of complex impedance' },
    { label: 'cd', doc: 'VT_ZIMAG - Measured imaginary part of complex impedance' },
    { label: 'ce', doc: 'VT_EIS_TDD_E - Measured RE potential Time Domain Data' },
    { label: 'cf', doc: 'VT_EIS_TDD_I - Measured WE current Time Domain Data' },
    { label: 'cg', doc: 'VT_EIS_FS - Sampling frequency used for EIS measurement' },
    { label: 'ch', doc: 'VT_EIS_E_AC - Measured AC potential' },
    { label: 'ci', doc: 'VT_EIS_E_DC - Measured DC potential' },
    { label: 'cj', doc: 'VT_EIS_I_AC - Measured AC current' },
    { label: 'ck', doc: 'VT_EIS_I_DC - Measured DC current' },
    { label: 'cl', doc: 'VT_ZREAL_BIPOT - Measured real part of complex bipot impedance' },
    { label: 'cm', doc: 'VT_ZIMAG_BIPOT - Measured imaginary part of complex bipot impedance' },
    { label: 'cn', doc: 'VT_ZREAL_S2_VS_RE - Measured real part of complex second sense impedance' },
    { label: 'co', doc: 'VT_ZIMAG_S2_VS_RE - Measured imaginary part of complex second sense impedance' },
    { label: 'cp', doc: 'VT_ZREAL_SE_VS_S2 - Measured real part of complex second sense impedance' },
    { label: 'cq', doc: 'VT_ZIMAG_SE_VS_S2 - Measured imaginary part of complex second sense impedance' },
    { label: 'cr', doc: 'VT_EIS_TDD_BIPOT - Measured bipot current time domain data' },
    { label: 'cs', doc: 'VT_EIS_TDD_S2_VS_RE - Measured S2 vs RE potential time domain data' },
    { label: 'ct', doc: 'VT_EIS_TDD_SE_VS_S2 - Measured SE vs S2 potential time domain data' },
    { label: 'cu', doc: 'VT_EIS_AC_BIPOT - Measured AC bipot current' },
    { label: 'cv', doc: 'VT_EIS_DC_BIPOT - Measured DC bipot current' },
    { label: 'cw', doc: 'VT_EIS_AC_S2_VS_RE - Measured AC S2 vs RE potential' },
    { label: 'cx', doc: 'VT_EIS_DC_S2_VS_RE - Measured DC S2 vs RE potential' },
    { label: 'cy', doc: 'VT_EIS_AC_SE_VS_S2 - Measured AC SE vs S2 potential' },
    { label: 'cz', doc: 'VT_EIS_DC_SE_VS_S2 - Measured DC SE vs S2 potential' },
    { label: 'da', doc: 'VT_CELL_SET_POTENTIAL - Set control value for WE potential' },
    { label: 'db', doc: 'VT_CELL_SET_CURRENT - Set control value for WE current' },
    { label: 'dc', doc: 'VT_CELL_SET_FREQUENCY - Set value for frequency' },
    { label: 'dd', doc: 'VT_CELL_SET_AMPLITUDE - Set value for ac amplitude' },
    { label: 'ea', doc: 'VT_CHANNEL - The channel' },
    { label: 'eb', doc: 'VT_TIME - Time in seconds' },
    { label: 'ec', doc: 'VT_PIN_MSK - Binary pin bitmask, indicating which pins are high / low' },
    { label: 'ed', doc: 'VT_TEMPERATURE - CPU temperature in degrees Celsius' },
    { label: 'ee', doc: 'VT_COUNT - Count (e.g. number of data points)' },
    { label: 'ef', doc: 'VT_TEMPERATURE_BOARD - Board temperature in degrees Celsius' },
    { label: 'ha', doc: 'VT_CURRENT_GENERIC1 - Generic current 1' },
    { label: 'hb', doc: 'VT_CURRENT_GENERIC2 - Generic current 2' },
    { label: 'hc', doc: 'VT_CURRENT_GENERIC3 - Generic current 3' },
    { label: 'hd', doc: 'VT_CURRENT_GENERIC4 - Generic current 4' },
    { label: 'ia', doc: 'VT_POTENTIAL_GENERIC1 - Generic potential 1' },
    { label: 'ib', doc: 'VT_POTENTIAL_GENERIC2 - Generic potential 2' },
    { label: 'ic', doc: 'VT_POTENTIAL_GENERIC3 - Generic potential 3' },
    { label: 'id', doc: 'VT_POTENTIAL_GENERIC4 - Generic potential 4' },
    { label: 'ja', doc: 'VT_MISC_GENERIC1 - Miscellaneous value 1 (reserved for user code)' },
    { label: 'jb', doc: 'VT_MISC_GENERIC2 - Miscellaneous value 2 (reserved for user code)' },
    { label: 'jc', doc: 'VT_MISC_GENERIC3 - Miscellaneous value 3 (reserved for user code)' },
    { label: 'jd', doc: 'VT_MISC_GENERIC4 - Miscellaneous value 4 (reserved for user code)' },
];

export const VALID_VARTYPES = new Set(VARTYPES.map((v) => v.label));
